export enum WebMessageCareerPosition {
	Tester = "Tester",
	Developer = "Developer",
	Manager = "Manager",
	GraphicDesigner = "GraphicDesigner",
}
